export function IntegrationDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.INTEGRATION + '/:action')
        .setCustomActions({
            'get': {
                method: 'GET',
                isArray: true
            },
            'addOrUpdate': {
                method: 'POST',
                notifications: true
            },
            'validate': {
                method: 'POST',
                params: {action: 'validateAuth'},
                notifications: true
            },
            'delete': {
                method: 'DELETE',
                params: {action: '@vendorToDelete'},
                notifications: true
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/integration_dao.js